import axios from "axios";
import { Constants } from "../utils/Constants";

export function login(data) {
    return axios.post(`${Constants.baseUrl}/auth`, data);
}

export function forgot(data) {
    return axios.post(`${Constants.baseUrl}/forgot-password`, data);
}

export function reset(data) {
    return axios.post(`${Constants.baseUrl}/reset-password`, data);
}

export function forgotPasswordValidateCode(data) {
    return axios.post(`${Constants.baseUrl}/forgot-password-code`, data);
}

export function signin(data) {
    return axios.post(`${Constants.baseUrl}/signin`, data);
}

export function resetPassword(data) {
    return axios.post(`${Constants.baseUrl}/reset-password`, data);
}

export function resetPasswordFirstAccess(data) {
    return axios.post(`${Constants.baseUrl}/customer/reset-password-first-access`, data);
}

export function logout() {
    return axios.post(`${Constants.baseUrl}/logout`);
}
